const requiredSpecs = {
  hour_wage_range: {
    wage_month: false,
    wage_month_min: false,
    wage_month_max: false,
    wage_hour: false,
    wage_hour_min: true,
    wage_hour_max: true,
  },
  hour_wage_exact: {
    wage_month: false,
    wage_month_min: false,
    wage_month_max: false,
    wage_hour: true,
    wage_hour_min: false,
    wage_hour_max: false,
  },
  month_wage_range: {
    wage_month: false,
    wage_month_min: true,
    wage_month_max: true,
    wage_hour: false,
    wage_hour_min: false,
    wage_hour_max: false,
  },
  month_wage_exact: {
    wage_month: true,
    wage_month_min: false,
    wage_month_max: false,
    wage_hour: false,
    wage_hour_min: false,
    wage_hour_max: false,
  },
};

const SalaryTab = {
  create(node) {
    this.node = node;
    this.salaryTypeSelect = this.node.querySelector('#google_jobs_salary_type');

    if (!this.salaryTypeSelect) {
      throw new Error('Salary type select is unavailable');
    }

    this.check();

    this.salaryTypeSelect.addEventListener('change', () => {
      this.check();
    });
  },

  check() {
    const chosenSalaryType = this.salaryTypeSelect.value;

    if (!chosenSalaryType) {
      return;
    }

    const requiredSpec = requiredSpecs[chosenSalaryType];

    if (typeof requiredSpec === 'undefined') {
      throw new Error(`Cannot find required spec for salary type ${chosenSalaryType}`);
    }

    Object.keys(requiredSpec).forEach((key) => {
      const element = this.node.querySelector(`[name="${key}"]`);

      if (!element) {
        return;
      }

      const isRequired = requiredSpec[key];

      element[isRequired ? 'setAttribute' : 'removeAttribute']('required', 'required');
    });
  },
};

export default SalaryTab;
